export default {
  default: {
    paragraphOne:
      'Forms can be used to collect any information you need associated with a project. If you haven’t created a digital page with a form and sent it yet you’ll need to do that first. Once someone responds to a form the results will be available here.',
    paragraphTwo: 'Once someone responds to a form the results will be available here.',
    title: 'No Responses Collected',
  },
}
